<template lang='pug'>
    el-dialog.modal-upload-solicitacao-lote(
        :visible.sync='show',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        width='70%'
    )
        template(slot='title')
            div.modal-upload-solicitacao-lote__titulo {{ $t('mensagens.operacao.modalInibirLote.titulo') }}

        section
            div.mb-2
                span.mr-2(style='color: red') *
                span.font-weight-bold {{ $t('mensagens.operacao.modalInibirLote.labelTutorial') }}

            div.mb-4  {{ $t('mensagens.operacao.modalInibirLote.texto1') }}

            div.mb-2
                i.mdi.mdi-alert-circle.mr-2(style='color: #DDAC44; font-size: 16px')
                span.font-weight-bold  {{ $t('mensagens.operacao.atencao') }}

            div.mb-4 {{ $t('mensagens.operacao.modalTextoComum.texto1') }}
                |  {{ $t('mensagens.operacao.modalTextoComum.texto2') }}
                | {{ $t('mensagens.operacao.modalTextoComum.texto3') }}

            section(v-show='arquivoEscolhido.length === 0')
                el-upload(
                    action='#',
                    :auto-upload='false'
                    :on-change='enviarPlanilha',
                    :on-exceed='onExceed',
                    :file-list='fileList'
                    :limit='1',
                    drag,
                    ref='refUploadInibicaoLote'
                ).mb-2
                    i.el-icon-upload
                    .el-upload__text {{ $t('mensagens.operacao.textoUpload1') }} <em>{{ $t('mensagens.operacao.textoUpload2') }}</em>
                span {{ $t('mensagens.operacao.textoUpload3') }}

            div(v-if='arquivoEscolhido.length > 0')
                el-table(
                    height='100%',
                    :data='arquivoEscolhido',
                    style='width: 100%'
                )
                    el-table-column(prop='planilha_importada', :label="$t('mensagens.operacao.planilhaImportada')")

                    el-table-column(prop='status', :label="$t('mensagens.operacao.status')")
                        template(slot-scope='scope')
                            el-tag(:type='scope.row.status.type', size='medium')
                                el-icon.mr-2(:class='scope.row.status.icon')
                                | {{ $t(`mensagens.operacao.${scope.row.status.codigo}`) }}

                    el-table-column(v-if="arquivoEscolhido[0].status.id === 2", prop='planilha_com_erro', :label="$t('mensagens.operacao.planilhaErro')")
                        template(slot-scope='scope')
                            BaseButton(
                                icon='el-icon-download',
                                type='primary',
                                size='mini',
                                @click='downloadArquivoErro'
                            ) {{ $t('mensagens.operacao.acoes.download') }}

        template(slot='footer')
            div.d-flex.justify-content-between
                BaseButton(@click='fechar')
                    | {{ $t('mensagens.operacao.acoes.cancelar') }}
                BaseButton(type='primary', :disabled='desabilitarConfirmar', @click='solicitarInibicaoEmLote')
                    | {{ $t('mensagens.operacao.acoes.confirmar') }}
</template>

<script>
import OperacaoService from '@/services/OperacaoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalUploadInibicaoEmLote',
    components: {
        BaseButton
    },
    emits: ['atualizar'],
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            arquivoEscolhido: [],
            arquivoHash: null,
            desabilitarConfirmar: true,
            status: [
                { id: 1, nome: this.$t('mensagens.operacao.EM_PROCESSAMENTO'), codigo: 'EM_PROCESSAMENTO', type: 'info', icon: 'el-icon-loading' },
                { id: 2, nome: this.$t('mensagens.operacao.ARQUIVO_ERRO'), codigo: 'ARQUIVO_ERRO', type: 'danger', icon: 'el-icon-warning-outline' },
                { id: 3, nome: this.$t('mensagens.operacao.PROCESSADO'), codigo: 'PROCESSADO', type: 'success', icon: 'el-icon-circle-check' }
            ],
            fileList: [],
            mostrarDialog: false
        };
    },

    methods: {
        async enviarPlanilha(planilha) {
            if (this.arquivoEscolhido.length > 0) {
                this.$notify.warning({
                    message: this.$t('mensagens.operacao.notificacao.enviarPlanilha')
                });
                this.$refs.refUploadInibicaoLote.clearFiles();
                return;
            }

            if (planilha.size > 15000000) {
                this.$notify.warning({
                    message: this.$t('mensagens.operacao.notificacao.ultrapassa15MB')
                });
                this.$refs.refUploadInibicaoLote.clearFiles();
                return false;
            }

            let extension = planilha.name.split('.').pop().toLowerCase();
            if (extension !== 'xlsx' && extension !== 'xls') {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.tipoNaoSuportado')
                });
                this.$refs.refUploadCancelamentoLote.clearFiles();
                return false;
            }

            try {
                this.arquivoEscolhido.push({
                    planilha_importada: planilha.name,
                    status: this.status[0]
                });

                await OperacaoService.validarPlanilhaInibicao(planilha)
                    .then(({ data }) => {
                        if (data.status === 'VALIDO') {
                            this.arquivoEscolhido[0].status = this.status[2];
                            this.desabilitarConfirmar = false;
                            this.arquivoHash = data.hash;

                            this.$notify.success({
                                message: this.$t('mensagens.operacao.notificacao.sucessoNoArquivo')
                            });
                        } else {
                            this.arquivoEscolhido[0].status = this.status[1];
                            this.arquivoHash = data.hash;

                            this.$notify.warning({
                                message: this.$t('mensagens.operacao.notificacao.arquivoComErro')
                            });
                        }
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: this.$t('mensagens.operacao.notificacao.arquivoNaoProcessado')
                        });
                        setTimeout(() => this.limpar(), 1000);
                    });

            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.uploadErro')
                });
            }
            this.$refs.refUploadCancelamentoLote.clearFiles();
        },

        async downloadArquivoErro() {
            await OperacaoService.downloadPlanilhaErroInibicao(this.arquivoHash + '.' +
                this.arquivoEscolhido[0].planilha_importada.split('.').pop())
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.operacao.notificacao.downloadRealizado')
                    });
                })
                .catch(() =>
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.downloadErro')
                    })
                );
        },

        onExceed() {
            this.$notify.warning({
                message: this.$t('mensagens.operacao.notificacao.uploadUnico'),
                position: 'top-left'
            });
        },

        async solicitarInibicaoEmLote() {
            await OperacaoService.processarPlanilhaInibicao(this.arquivoHash + '.' +
                this.arquivoEscolhido[0].planilha_importada.split('.').pop())
                .then(({ data }) => {
                    this.$notify.success({
                        message: data
                    });
                    this.fechar();
                    this.$emit('atualizar');
                })
                .catch(() =>
                    this.$notify.error({
                        message:
                            this.$t('mensagens.operacao.notificacao.solicitacaoErro')
                    })
                );
        },

        limpar() {
            this.arquivoEscolhido = [];
            this.arquivoHash = null;
            this.$refs.refUploadInibicaoLote.clearFiles();
        },

        fechar() {
            this.$emit('update:show', false);
            setTimeout(() => this.limpar(), 1000);
        }
    }
};
</script>

<style lang='scss'>
.modal-upload-solicitacao-lote {

    .modal-upload-solicitacao-lote__titulo {
        font-weight: bold;
        color: #00413C;
        font-size: 18px;
    }

    .el-dialog__body {
        padding: 20px !important;
        word-break: keep-all;
        word-wrap: break-word;
    }

    .el-dialog__header {
        padding-bottom: 20px !important;
        background: #E9E9E9;
    }

    .el-dialog__footer {
        padding-top: 20px !important;
        border-top: 1px solid #E9E9E9;
    }

    .el-dialog {
        background: white !important;
    }
}
</style>
